<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dkNRED/media/FC-9789948834748.jpg?1670934200822" alt="This image is the cover for the book If We Could"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If We Could
      </h1>
      <p class="bookDescription body article font2">
        <p>Why are we stuck with work issues, facing challenges and problems? We may have the talent and skills, but where and how to better use them is a real struggle. Walk through the journey of the author who started just like you and find out where the obstacle is, after all! Discover through her lines where the real problem lies and why you are the only person who has the potential to solve it. It’s your journey too, isn’t it?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aisha Riaz
      </h2>
      
      <p class="authorDescription body article">Aisha Riaz is a young professional who is inspired from leaders around the world to write about organizational issues, employee empowerment, and to make a workplace better for employees. She has recently completed her CIPD studies after graduating from the American College of Dubai with a bachelor’s degree in business. Born and raised in Dubai, she enjoys working in a multicultural environment as she believes that helps her learn different cultures and teachings.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?436e4ee3